import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Document, FilesRequest, RequiredDocument } from '../../../../../interfaces/accidents.interface';
import { AccidentsService } from '../../../../../services/accidents.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ModalEnvioCorrectoComponent } from '../../../../../componentes/login/modal-envio-correcto/modal-envio-correcto.component';
import { GoogleAnalyticsService } from '../../../../../services/google-analytics/google-analytics.service';

@Component({
  selector: 'accidentes-documentos-requeridos',
  standalone: true,
  imports: [CommonModule, FormsModule, ModalEnvioCorrectoComponent],
  templateUrl: './documentos-requeridos.component.html',
  styleUrl: './documentos-requeridos.component.css'
})
export class DocumentosRequeridosComponent implements OnInit {
  
  public filesToUpload: Document[] = [];
  public selectedFiles: RequiredDocument[] = [];

  @Input() public alreadyUploadedDocuments?: Document[];
  @Input() public eventNumber: string = '';
  @Input() public policyNumber: string = '';
  @Input() public lossType?: number; //Default loss Type = 1
  @Input() public coverageCode?: number;
  @Output() refreshInfo = new EventEmitter<void>();

  // Modal envio correcto
  public showModal = false;

  onContinue(): void {
    this.showModal = false;
    this.refreshInfo.emit()
  }


  constructor(private accidentService: AccidentsService,private gAnalytics:GoogleAnalyticsService) { }
  ngOnInit(): void {
    this.getFiles();
  }

  onFileSelected(event: Event, code: number, type: number): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const document = this.selectedFiles.find((d) => d.code === code);

      if (!!document) {
        document.file = input.files[0];
      } else {
        const file = input.files[0];
        this.selectedFiles.push({
          code,
          type,
          file,
          postMarkDate: new Date(),
        });
      }
    }
  }

  getFiles() {
    this.filesToUpload = []; // Limpieza de datos existentes
    const request: FilesRequest = {
      PolicyNumber: this.policyNumber!,
      LossType: this.lossType!,
      CoverageCode: this.coverageCode!,
    };

    this.accidentService.getData('files', request).subscribe({
      next: (response) => {
        if (response.documents.length) {
          const alreadyUploadDocumentsCode: number[] = this.alreadyUploadedDocuments?.map(d => d.code)!;
          this.filesToUpload = response.documents.filter(f => !alreadyUploadDocumentsCode.includes(f.code));
        }
      },
      error: (error) => {
        console.error('Error al obtener las archivos a subir:', error);
        if (error.statusCode === 404) {
          console.warn(
            'No se encontraron los archivos a subir para los datos ingresados.'
          );
        }
      },
    });

  }

  onUploadFile() {
    if (!this.selectedFiles.length) return;

    const request: FormData = new FormData();

    request.append('EventNumber', this.eventNumber.toString());

    for (let i = 0; i < this.selectedFiles.length; i++) {
      let currentDoc = this.selectedFiles[i];
      request.append(`Documents[${i}].Code`, currentDoc.code.toString());
      request.append(`Documents[${i}].Type`, currentDoc.type.toString());
      request.append(`Documents[${i}].File`, currentDoc.file!);
      request.append(`Documents[${i}].PostMarkDate`, new Date().toDateString());
    }

    this.accidentService.uploadFile(request).subscribe({
      next: response => {
        if(response.isSuccessful){
          this.showModal = true;
          this.gAnalytics.trackEvent('archivo_cargado',{
          action:'Carga de archivo pendiente en un reclamo',
          page:'/accidentes',
      })
        }
        console.log(response)
      },
      error: (error) => {
        console.error('Error al subir los documentos requeridos:', error);
        if (error.statusCode === 500) {
          console.error('Error inesperado en el servidor:', error.message || error);
          window.alert(
            'Error inesperado al subir los documentos requeridos. Por favor, intente nuevamente más tarde. Si el problema persiste, contacte a su administrador de cuentas.'
          );
        } else {
          console.error(error);
        }
      },
    })
  }

}
